import styled, {keyframes} from "styled-components";

export const ChoosePlansContainer = styled.div`
  display: flex;
  background-color: #FE2F67;
  align-items: center;
  flex-direction: column;
  flex: 1;
`

export const ChoosePlansHeadersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px 0;
  text-align: center;
`

export const ChoosePlansHeader = styled.h1`
  color: white;
  margin-bottom: 10px;
  
  @media (max-width: 600px){
    font-size: 25px;
  }
`

export const ChoosePlansSubText = styled.h2`
  color: white;
  letter-spacing: 2px;
  margin-top: 5px;

  @media (max-width: 600px){
    font-size: 20px;
  }
`

export const ChooesPlansCardsCarousel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
